import React from 'react';
import { Icon } from '@ontruck/orc';

const handlingByStopType = {
  PICKUP: 'HANDLING_LOADING',
  DROPOFF: 'HANDLING_UNLOADING',
};

// The icons are wrong-named
const handlingIconByStopType = {
  PICKUP: 'extra-drop',
  DROPOFF: 'extra-pick',
};

const StopExtras = React.memo(({ extras = [], stop_type }) => {
  const extraValue = handlingByStopType[stop_type] || [];

  return (
    extras.includes(extraValue) && (
      <Icon glyph={handlingIconByStopType[stop_type]} size="1.6rem" color="grey500" />
    )
  );
});

export default StopExtras;
